import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconGear(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53544 8.5H3V9.5H5.53544C5.51209 9.3367 5.5 9.16976 5.5 9C5.5 8.83024 5.51209 8.6633 5.53544 8.5ZM6.19681 6.90391C6.39756 6.63587 6.63587 6.39756 6.90391 6.19681L5.11091 4.4038L4.4038 5.11091L6.19681 6.90391ZM8.5 5.53544C8.6633 5.51209 8.83024 5.5 9 5.5C9.16976 5.5 9.3367 5.51209 9.5 5.53544V3H8.5V5.53544ZM11.0961 6.19681C11.3641 6.39756 11.6024 6.63587 11.8032 6.90391L13.5962 5.11092L12.8891 4.40381L11.0961 6.19681ZM12.4646 8.5C12.4879 8.6633 12.5 8.83024 12.5 9C12.5 9.16976 12.4879 9.3367 12.4646 9.5H15V8.5H12.4646ZM11.8032 11.0961C11.6024 11.3641 11.3641 11.6024 11.0961 11.8032L12.8891 13.5962L13.5962 12.8891L11.8032 11.0961ZM9.5 12.4646C9.3367 12.4879 9.16976 12.5 9 12.5C8.83024 12.5 8.6633 12.4879 8.5 12.4646V15H9.5V12.4646ZM6.90391 11.8032C6.63587 11.6024 6.39756 11.3641 6.19681 11.0961L4.4038 12.8891L5.11091 13.5962L6.90391 11.8032Z"
        fill="currentColor"
      />
      <circle cx="9" cy="9" r="3.5" stroke="currentColor" />
    </SVGIcon>
  );
}
